var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokelau(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00247d",
    d: "M0 .05h30v23.9H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#f1b31c",
    d: "M25 3a30 30 0 0 0-1.5 9q0 4.24 4.5 6H4zm5 17v2H0v-2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m11 5.9.24.76H12l-.62.48.24.76-.62-.47-.62.47.24-.76-.62-.48h.76zm-3.42-4 .37 1.14h1.2l-.97.71.37 1.15-.97-.7-.98.7.37-1.15-.97-.7h1.2zm0 8 .37 1.14h1.2l-.97.71.37 1.15-.97-.7-.98.7.37-1.15-.97-.7h1.2zm-4-3 .37 1.14h1.2l-.97.71.37 1.15-.97-.7-.98.7.37-1.15-.97-.7h1.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokelau);
export default __webpack_public_path__ + "static/media/tokelau.47412724369b9ade8da7cde5dcac88d2.svg";
export { ForwardRef as ReactComponent };